import styled from "@emotion/styled";
import { Token } from "store/global/TokenEnum";
import { getTokenIcon } from "utils/tokenIconUtils";
import React from "react";
import { ActivityStore } from "../../store/activity/ActivityStore";

export enum Direction {
  Vertical,
  Horizontal,
}

interface TokenStackedArrayProps {
  direction: Direction;
  tokens: Array<Token>;
  tokenSize: number;
}

export const TokenStackedArray = React.memo(
  ({ direction, tokens, tokenSize }: TokenStackedArrayProps) => {
    const tokenMetadata = ActivityStore.useState(s => s.tokens);
    return (
      <Container size={tokenSize} tokenLength={tokens.length} direction={direction}>
        {tokens.map((symbol, index) => (
          <TokenIcon
            src={getTokenIcon(symbol, tokenMetadata)}
            tokenIndex={index}
            tokenCount={tokens.length}
            direction={direction}
            size={tokenSize}
            alt={symbol}
            key={symbol}
          />
        ))}
      </Container>
    );
  }
);

// Sub-components

const Container = styled.div<{ size: number; tokenLength: number; direction: Direction }>`
  position: relative;
  width: ${props =>
    props.direction === Direction.Horizontal
      ? props.size + GAP_BETWEEN_ICON_HORIZONTAL * (props.tokenLength - 1)
      : props.size}px;
  height: ${props =>
    props.direction === Direction.Horizontal
      ? props.size
      : props.size + GAP_BETWEEN_ICON_VERTICAL * (props.tokenLength - 1)}px;
`;

export const TokenIcon = styled.img<{
  tokenIndex: number;
  tokenCount: number;
  size: number;
  direction: Direction;
}>(props => ({
  position: props.tokenIndex === 0 ? "relative" : "absolute",
  top:
    props.direction === Direction.Vertical
      ? `${GAP_BETWEEN_ICON_VERTICAL * props.tokenIndex}px`
      : "0",
  left:
    props.direction === Direction.Horizontal
      ? `${GAP_BETWEEN_ICON_HORIZONTAL * props.tokenIndex}px`
      : "0",
  zIndex: `${10 - props.tokenIndex}`,
  width: `${props.size}px`,
  height: `${props.size}px`,
  filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
}));

// Helpers

const GAP_BETWEEN_ICON_VERTICAL = 5;
const GAP_BETWEEN_ICON_HORIZONTAL = 18;
